module.exports = __webpack_public_path__ + "static/media/welder-yellow.571c0ded.svg";